import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=1f5b05c6&"
import script from "./ProcessForm.vue?vue&type=script&lang=ts&"
export * from "./ProcessForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports